export const Base_URL = process.env.REACT_APP_BASE_URL || "https://backend.swiftuni.com" || "http://localhost:8080";

export const Base_URL_AiScore = process.env.REACT_APP_AI_SCORE_URL || "https://ai.swiftuni.com";

export const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL || "https://swift-uni-user-images.s3.us-east-1.amazonaws.com";
